import { ResourceMetadataKey } from "@/components/FileManager/models/ResourceMetadataKey";
import { ResourceRequestArgs } from "@/components/FileManager/models/ResourceRequestArgs";

export interface GetRulesArgsOptions {
    tenantId: string;
    userId: string;
    fileId: string;
}

export class GetRulesArgs extends ResourceRequestArgs {

    public key: ResourceMetadataKey = ResourceMetadataKey.DataCleaning
    public tenantId: string;
    public userId: string;
    public fileId: string;

    constructor(options: GetRulesArgsOptions) {
        super();
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.userId == null) throw Error("userId is required");
        if (options.fileId == null) throw Error("fileId is required");

        this.tenantId = options.tenantId;
        this.userId = options.userId;
        this.fileId = options.fileId;
    }

}